import { render, staticRenderFns } from "./TopStatistics.vue?vue&type=template&id=278e7b62&scoped=true&"
import script from "./TopStatistics.vue?vue&type=script&lang=js&"
export * from "./TopStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TopStatistics.vue?vue&type=style&index=0&id=278e7b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e7b62",
  null
  
)

export default component.exports